import {authHeaders, handleResponse} from "./apiUtils";

const baseUrl = process.env.NODE_ENV === "production"
  ? "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/"
  : "http://localhost:3001/";

async function getLessonRegister(id) {
  const response = await fetch(`${baseUrl}lessonregister/${id}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function getLessonRegisters(fromDate, toDate) {
  const params = new URLSearchParams();

  if (fromDate) {
    params.append("fromDate", fromDate);
  }

  if (toDate) {
    params.append("toDate", toDate);
  }

  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await fetch(`${baseUrl}lessonregister/${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveLessonRegister(lessonRegister) {
  const lessonRegisterId = lessonRegister.id && lessonRegister.id !== lessonRegister.lessonId
    ? lessonRegister.id
    : (lessonRegister.lessonId || lessonRegister.id || "");
  const persistedRecordId = lessonRegister.id || lessonRegisterId;

  const response = await fetch(`${baseUrl}lessonregister/${lessonRegisterId}`, {
    method: "PUT",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify({
      ...lessonRegister,
      id: persistedRecordId,
    }),
  });
  return handleResponse(response);
}

async function deleteLessonRegister(id) {
  const response = await fetch(`${baseUrl}lessonregister/${id}`, {
    method: 'DELETE',
    headers: authHeaders({ 'content-type': 'application/json' }),
  });
  return handleResponse(response);
}

export default {
  getLessonRegister,
  getLessonRegisters,
  saveLessonRegister,
  deleteLessonRegister,
};
